import { Component, Injector, ViewEncapsulation, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { NotesFormComponent } from './notes-form/notes-form.component';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from '../common-data-model';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-notes-list',
  templateUrl: './notes-list.component.html',
  styleUrls: ['./notes-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class NotesListComponent extends AppComponentBase implements OnInit {

  @ViewChild('grid', { static: true }) private grid: GridComponent;
  @Output() emitNotes: EventEmitter<any> = new EventEmitter<any>();


  // @Input() vehicleId: any;
  @Input() set id(id: any) {
    if (id) {
      this.idForGetNotes = id;
      this.onRefreshGridData();
    }
  }

  idForGetNotes: any;
  notesDataModel = new CommonDataModel();
  notesModel = this.notesDataModel.notesModel;
  title: string;
  gridData: any;

  constructor(
    injector: Injector,
    private dialog: MatDialog,
    private commonService: CommonService,
    private router: Router) {
    super(injector);
  }

  ngOnInit(): void {
    // this.onRefreshGridData();
  }

  onRefreshGridData(): void {
    this.kendogridHelper.sort = [{ dir: 'desc', field: 'createdDate' }];
    this.grid.dataStateChange.emit({
      skip: 0,
      take: 5,
      filter: undefined,
      group: undefined,
      sort: this.kendogridHelper.sort,
    });
  }

  getGridRecords(event: DataStateChangeEvent): void {
    if (event) {
      this.kendogridHelper.dataStateChangeEvent(event);
    }
    this.kendogridHelper.showLoadingIndicator();
    let queryParams = ``;
    if (this.router.url.indexOf('customer-details') !== -1 || this.router.url.indexOf('job-details') !== -1) {
      this.title = 'Customer';
      this.getAccountNotes();
    } else if (this.router.url.indexOf('lead-details') !== -1) {
      this.title = 'Lead';
      this.getAccountNotes();
    } else if (this.router.url.indexOf('job-form') !== -1 || this.router.url.indexOf('quote-form') !== -1 ||
      this.router.url.indexOf('job-details?jobId') !== -1 || this.router.url.indexOf('quote-details?quoteId') !== -1) {
      this.getAccountNotes();
    } else {
      this.title = 'Vehicle';
      queryParams = this.idForGetNotes ? `&VehicleId=${this.idForGetNotes}&IsActive=true` : '';
      this.commonService.getNotesGridRecords(event, queryParams)
      .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe(response => {
        this.gridData = response.data;
        this.kendogridHelper.setGridData(this.gridData);
        this.kendogridHelper.hideLoadingIndicator();
      });
    }
  }

  getAccountNotes() {
    const queryParams = this.idForGetNotes ? `AccountId=${this.idForGetNotes}` : '';
    this.kendogridHelper.showLoadingIndicator();
    this.commonService.gerAccountNotes(queryParams)
    .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe((response: any) => {
      this.gridData = response.data;
      this.kendogridHelper.setGridData(this.gridData);
      this.emitNotes.emit();
      this.kendogridHelper.hideLoadingIndicator();
    });
  }

  onOpenForm(vehicle?: any): void {
    this.notesModel.vehicleId = this.idForGetNotes;
    this.notesModel.vehicleNoteId = vehicle ? vehicle.vehicleNoteId : null ;
    this.dialog
      .open(NotesFormComponent, {
        position: {
          right: '0',
        },
        panelClass: 'small_layout',
        hasBackdrop: false,
        data: this.notesModel,
        autoFocus: false
      }).afterClosed()
      .subscribe((response) => {
        if (response) {
          this.onRefreshGridData();
        }
      });
  }
}
